import type { GlobConfig } from '/#/config';

import { getAppEnvConfig } from '/@/utils/env';

export const useGlobSetting = (): Readonly<GlobConfig> => {
  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_CAS_BASE_URL,
    VITE_GLOB_APP_OPEN_SSO,
    VITE_GLOB_DOMAIN_URL,
    VITE_SSE_PROXY,
    VITE_GLOB_QUES_DESIGNER_URL,
    VITE_GLOB_QUES_H5_URL,
    VITE_GLOB_OFFICIAL_URL,
    VITE_GLOB_K8H5_URL,
    VITE_GLOB_DATA_EASE_URL,
    VITE_GLOB_OFFICIAL_PHONE,
    VITE_GLOB_FILE_PREVIEW_URL,
    VITE_GLOB_SPP_TENANT_ID,
    VITE_GLOB_VOD_PROVIDER
  } = getAppEnvConfig();

  if (!/[a-zA-Z\_]*/.test(VITE_GLOB_APP_SHORT_NAME)) {
    // warn(
    //   `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`
    // );
  }

  // Take global configuration
  const glob: Readonly<GlobConfig> = {
    title: VITE_GLOB_APP_TITLE,
    domainUrl: VITE_GLOB_DOMAIN_URL,
    sseUrl: VITE_SSE_PROXY,
    apiUrl: VITE_GLOB_API_URL,
    shortName: VITE_GLOB_APP_SHORT_NAME,
    openSso:VITE_GLOB_APP_OPEN_SSO,
    casBaseUrl:VITE_GLOB_APP_CAS_BASE_URL,
    urlPrefix: VITE_GLOB_API_URL_PREFIX,
    uploadUrl: VITE_GLOB_API_URL,
    quesDesignerUrl: VITE_GLOB_QUES_DESIGNER_URL,
    quesH5Url: VITE_GLOB_QUES_H5_URL,
    officialUrl: VITE_GLOB_OFFICIAL_URL,
    k8H5Url:VITE_GLOB_K8H5_URL,
    dataEaseUrl: VITE_GLOB_DATA_EASE_URL,
    officialPhone: VITE_GLOB_OFFICIAL_PHONE,
    filePreviewUrl: VITE_GLOB_FILE_PREVIEW_URL,
    sppTenantId: VITE_GLOB_SPP_TENANT_ID,
    vodProvider: VITE_GLOB_VOD_PROVIDER
  };
  window._CONFIG['domianURL'] = VITE_GLOB_DOMAIN_URL
  return glob as Readonly<GlobConfig>;
};
